define('app/helper/texttospeech.se',[], function () {

  var SpeechNative = function () {
      var synth = window.speechSynthesis,
        utterInst,
        BASE_RATE = 1 / 0.9,

        isMobile = false,
        isInit = true

      function init () {
        var _res = $.Deferred()

        _res.resolve()

        return _res.promise()
      }

      function speak (text, voice, options) {

        options = Object.assign({
          pitch: 1,
          rate: 1,
          volume: 1,
          onstart: function () {
          },
          onend: function () {
          }
        }, options || {})
        voice = voice || options.voice || synth.getVoices()[0]

        options.rate *= BASE_RATE

        var utter = utterInst = new SpeechSynthesisUtterance(text)

        utter.voice = voice
        utter.lang = voice.lang
        utter.pitch = options.pitch
        utter.rate = options.rate

        if (synth.pending || synth.speaking) {
          synth.cancel()
        }
        // hack for sometimes missig "on-end" event
        var checkEndInterval,
          onendFn = function () {
            clearInterval(checkEndInterval)
            options.onend.apply(this)
          }

        utter.onstart = options.onstart
        utter.onend = onendFn

        onend = onendFn

        var _res = synth.speak(utter)

        checkEndInterval = setInterval(function () {
          if (!synth.speaking) {
            onendFn.apply(this)
          }
        }, 100)
      }

      function cancel () {
        return synth.cancel()
      }

      if (!synth || !SpeechSynthesisUtterance) {
        console.error('Sorry, your browser does not support native speech synthesis. Please switch to latest Chrome or Firefox.')
        return {
          speak: function () {},
          cancel: function () {},
          init: init,
          inst: utterInst
        }
      }

      return {
        speak: speak,
        cancel: cancel,
        init: init,
        getInst: function () { return utterInst }
      }
    },
    SpeechRV = function () {
      var onend = function () {},
        rvReady,
        rvInitializing = false,
        responsiveVoice,
        BASE_RATE = 1,
        DEFAULT_VOICE = 'US English Female'

      function constructor () {
        if (window.responsiveVoice) {
          responsiveVoice = window.responsiveVoice

          rvInit()

        } else {
          require(['//code.responsivevoice.org/responsivevoice.js'], function (_rV) {
            responsiveVoice = window.responsiveVoice

            rvInit()
          })
        }
      }

      constructor()

      function rvInit () {
        var rv = responsiveVoice

        rvReady = rvReady || $.Deferred()

        if (rv && !rvInitializing) {
          rvInitializing = true
          rv.init()

          if ((rv.iOS && !rv.iOS_initialized) ||
            (rv.android && !rv.android_initialized)) {

            $('body').one('touchend', function (ev) {
              rv.speak('Starting', null, { // ios needs to have some "meat" to it .. cant speak an empty msg
                volume: 0,
                onend: function () {
                  rvReady.resolve()
                }
              })
            })

          } else {
            rvReady.resolve()
          }
        }

        return rvReady.promise()
      }

      function speak (text, voice, options) {
        rvReady = rvInit()

        options = Object.assign({
          pitch: 1,
          rate: 1,
          volume: 1,
          onstart: function () {
          },
          onend: function () {
          }
        }, options || {})
        voice = voice || options.voice || DEFAULT_VOICE

        options.rate *= BASE_RATE

        onend = options.onend

        return rvReady.then(function () {
          return responsiveVoice.speak(text, voice, options)
        })
      }

      function cancel () {
        onend.apply(this)

        if (responsiveVoice)
          return responsiveVoice.cancel()

        return
      }

      return {
        speak: speak,
        cancel: cancel,
        init: rvInit,
        getInst: function () { return responsiveVoice }
      }
    }

  return {
    Native: SpeechNative,
    ResponsiveVoice: SpeechRV
  }
});
